/**
 * DOOH: (Σ selected screens' DiscountedPrice) × day-block × seconds-block.
 *
 *   - screens: sum of the selected screens' DiscountedPrice (respective rates)
 *   - days:    tenBlockFactor(days)    → 10 ×1, 20 ×2, 30 ×3
 *   - seconds: tenBlockFactor(seconds) → 10 ×1, 20 ×2, 30 ×3
 *
 *   Total = Σ(screen DiscountedPrice) × tenBlockFactor(days) × tenBlockFactor(seconds)
 *
 * Screens come from selection.HoardingList (digital-ads grid) or selection.ProductsToBuy.
 */
import { tenBlockFactor } from './multipliers';

export function calculateDoohTotal(variant, selection) {
  const screenList = selection?.HoardingList || selection?.ProductsToBuy || [];
  if (!screenList.length) return 0;

  const sumDiscounted = screenList.reduce(
    (sum, row) => sum + (Number(row?.DiscountedPrice) || 0),
    0
  );
  const days = Number(selection?.timelineToBought) || 0;
  const seconds = Number(selection?.BoughtSeconds) || 0;
  return sumDiscounted * tenBlockFactor(days) * tenBlockFactor(seconds);
}
